export default "__VITE_ASSET__4vrKHlBk__"